import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';

import Button from '../components/Button/Button';
import FlexBox from '../components/core/FlexBox';
import Heading from '../components/core/Heading';
import { MaticLogo } from '../components/core/icons';
import { useDocumentTitle } from '../hooks';
import { spacings } from '../theme/variables';
import { clearInteractiveLoginCooldown } from './entraAuthConfig';

const EntraLoginPage = () => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const navigate = useNavigate();
  useDocumentTitle('Login');

  const [isLoginIn, setIsLoginIn] = React.useState(false);

  const locationState = location.state as { from?: string; interactiveAuthFailed?: boolean } | null;
  // the Zendesk app has no "/" route, so return to wherever auth was interrupted
  const returnTo = locationState?.from || '/';

  if (isAuthenticated && !locationState?.interactiveAuthFailed) {
    return <Navigate to={returnTo} />;
  }

  return (
    <FlexBox alignItemsCenter justifyCenter columnDirection fitParentHeight gap={spacings.px16}>
      <FlexBox gap={spacings.px12} alignItemsCenter>
        <MaticLogo />
        <Heading type="h1">AMP</Heading>
      </FlexBox>
      <Button
        loading={isLoginIn}
        onClick={async () => {
          setIsLoginIn(true);

          try {
            const loginResponse = await instance.loginPopup({
              scopes: ['User.Read'],
              prompt: 'select_account'
            });
            instance.setActiveAccount(loginResponse.account);
            clearInteractiveLoginCooldown();
            navigate(returnTo, { replace: true });
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Entra login failed', error);
            setIsLoginIn(false);
          }
        }}
      >
        Sign in via Entra
      </Button>
    </FlexBox>
  );
};

export default EntraLoginPage;
